module.exports = __webpack_public_path__ + "img/white.be5030ca.webp";